/** Currencies shown without decimals (the minor unit is not used in everyday prices). */
const ZERO_DECIMAL = new Set(["JPY", "KRW", "ISK", "HUF", "VND", "CLP", "UGX"]);
export const currencyDigits = (c: string): number => (ZERO_DECIMAL.has(c) ? 0 : 2);

export function formatMoney(v: number, c: string): string {
  const d = currencyDigits(c);
  try { return new Intl.NumberFormat(undefined, { style: "currency", currency: c, minimumFractionDigits: d, maximumFractionDigits: d }).format(v); }
  catch { return `${v.toFixed(d)} ${c}`; }
}

/** null = fine; otherwise the reason the amount cannot be converted. */
export function amountProblem(raw: string): string | null {
  if (raw.trim() === "") return "Enter an amount.";
  const n = Number(raw);
  if (!Number.isFinite(n)) return "Enter a number, for example 100 or 49.99.";
  if (n < 0) return "The amount can't be negative.";
  return null;
}
